'use client';

import { useState } from 'react';

import Modal from '../Modal';
import { IUnavailableVillageModalDictionary } from '@/dictionaries/components/modals/types';

type Props = {
  dict: IUnavailableVillageModalDictionary;
  defaultOpen?: boolean;
};

export default function UnavailableVillaModal({
  defaultOpen = false,
  dict,
}: Props) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const { title, description } = dict;

  return (
    <Modal.Root open={isOpen} onOpenChange={setIsOpen}>
      <Modal.Content
        contentCustomClass="md:w-[600px] md:!top-[calc(50%-15vh)] md:!mb-0 desktop:w-[800px]"
        onOpenChange={setIsOpen}>
        <div className="w-full h-full flex flex-col justify-center text-center">
          <h5 className="font-averta-semibold mb-2 text-4xl text-center">
            {title}
          </h5>
          <p className="mt-8 mb-12  whitespace-pre-line">{description}</p>
        </div>
      </Modal.Content>
    </Modal.Root>
  );
}
